import { useMemo } from 'react';
import { KeyValueFieldsEditor } from '@/components/ui/KeyValueFieldsEditor';
import {
  keyValuePairsFromJson,
  keyValuePairsToJson,
  type KeyValuePair,
} from '@/utils/keyValueJson';

export const LEAD_MATCH_FIELD_OPTIONS = [
  { value: 'country', label: 'Country', placeholder: 'e.g. IN, US' },
  { value: 'state', label: 'State / province', placeholder: 'e.g. MH, CA' },
  { value: 'region', label: 'Region', placeholder: 'e.g. APAC' },
  { value: 'industry', label: 'Industry', placeholder: 'e.g. technology' },
  { value: 'companySize', label: 'Company size', placeholder: 'e.g. Enterprise' },
  { value: 'leadSource', label: 'Lead source', placeholder: 'e.g. WEBSITE' },
  { value: 'product', label: 'Product interest', placeholder: 'e.g. ERP' },
] as const;

type Props = {
  label?: string;
  hint?: string;
  value: string;
  onChange: (json: string) => void;
};

export function MatchCriteriaBuilder({ label = 'Match criteria', hint, value, onChange }: Props) {
  const pairs = useMemo(() => keyValuePairsFromJson(value), [value]);

  const handlePairsChange = (next: KeyValuePair[]) => {
    onChange(keyValuePairsToJson(next));
  };

  return (
    <KeyValueFieldsEditor
      label={label}
      hint={
        hint ??
        'All listed fields must match for this rule to apply. Leave empty to match any lead.'
      }
      pairs={pairs}
      onChange={handlePairsChange}
      fieldOptions={[...LEAD_MATCH_FIELD_OPTIONS]}
      addLabel="Add criterion"
    />
  );
}
